export enum FaxAnalyticsEvents {
  FileSelected = 'file_slctd',
  FileRemoved = 'file_removed',
  LinkCopied = 'link_copied',
  ConfirmationEmailAdded = 'conf_email_added',
  ConfirmationEmailRemoved = 'conf_email_removed',
  SendSuccess = 'send_success',
  SendFailure = 'send_failure',
}
